import request from '@/utils/request.js'
function getformData(obj) {
  return Object.keys(obj).reduce((pre, cur) => {
    pre.append(cur, obj[cur])
    return pre
  }, new FormData())
}
// 发送短信验证码
export const sendCode = phone => {
  return request({
    method: 'POST',
    url: '/weixin/sendSMS/zjspay/send',
    data: getformData({
      openid: phone,
      phone
    })
  })
}
// 验证短信是否正确
export const checkCode = data => {
  return request({
    method: 'POST',
    url: '/weixin/sendSMS/zjspay/verify',
    data: getformData({
      openid: data.phone,
      phone: data.phone,
      code: data.code
    })
  })
}
